import { render } from "./nav-highlights.vue?vue&type=template&id=6e73478d"
import script from "./nav-highlights.vue?vue&type=script&lang=js"
export * from "./nav-highlights.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__